import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSearchParams, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import classnames from 'classnames/bind';
import publicImage from '../../utils/publicImage';
import {
  IBreadCrumb,
  IModal,
  IRecommendations,
  IState,
  IVehicle,
  ProductCategory,
  Replacement,
} from '../../interface';
import style from './index.module.scss';
import Breadcrumb from '../Breadcrumb';
import Header from '../Header';
import VehicleDropdown from '../VehicleDropdown';
import CastrolRecommendation from './CastrolRecommendation';
import AlternativeRecommendation from './AlternativeRecommendation';
import Printable from '../RecommendationPrintable/Components';
import Loading from '../Loading';
import { connect } from 'react-redux';
import localesReplacement from '../../utils/localesReplacement';
import { Dispatch } from 'redux';
import actions from '../../redux/actions';
import { ModalHref } from '../../interface/emnu';
import Modal from '../Modal';
import FindTheRightOil from '../FindTheRightOil';
import UnderMaintenance from '../UnderMaintenance';
import { getRecommendations, /*getProduct*/ } from '../../services';
import { useAppName } from '../../hooks/use-app-names';
import { APPNAME, FASTSCAN } from '../../constants';
import { FailedRecommendation } from '../FailedRecommendation';
// import Parser from 'html-react-parser';

const cx = classnames.bind(style);
const primaryButton = "primary-button"

interface Props {
  modal: IModal;
  vehicle: IVehicle | undefined;
  replacements: Replacement;
  setModal: (value: IModal) => void;
  setVehicle: (value: IVehicle) => void;
  productCategoriesList: ProductCategory[] | null;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Product = (props: Props) => {
  const {
    modal,
    vehicle,
    replacements,
    setModal,
    setVehicle,
    productCategoriesList,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const i18n = localStorage.getItem('languageCode') as string;
  const country = (localStorage.getItem('countryCode') ||
    process.env.REACT_APP_COUNTRYCODE) as string;
  const [searchParams, setSearchParams] = useSearchParams();
  const vehicleId = searchParams.get('id');
  const [products, setProducts] = useState<IRecommendations[]>([]);
  const [dropdownClassName, setDropdownClassName] = useState<string>('');
  const [component, setComponent] = useState<number>(0);
  const [isMount, setIsMount] = useState<boolean>(false);
  //const [allRightsRsrdName, setAllRightsRsrdName] = useState<string>(' ');
  //const [allRightsRsrdMsg, setAllRightsRsrdMsg] = useState<string>(' ');
  //const productId = 77777 as number;
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);
  const breadcrumb: IBreadCrumb[] = [
    {
      value: 'Castrol',
      href: '#',
      static: true,
    },
    {
      value: 'Oil Selector',
      href: '#',
      static: true,
    },
    {
      value: 'Recommended oils',
      static: true,
    },
  ];
  useEffect(() => {
    setIsMount(true);
    setComponent(0);
    const controller = new AbortController();
    let isMounted = true;
    const isWorkshopOwner = _.isEqual(
      sessionStorage.getItem('selectedType'),
      'true'
    )
      ? true
      : false;
    vehicleId &&
      getRecommendations(vehicleId, isWorkshopOwner)
        .then((d) => {
          if(d.status !== 200){
            setUnderMaintenance(true);
            setIsMount(false);
            return;
          } 
          isMounted && setVehicle(d.data.vehicle);
          isMounted && setProducts(d.data.components);
          isMounted && setIsMount(false);
          //getAllRightsReservedInfo();
          
        })
        .catch(() => {
          setProducts([]);
          setIsMount(false);
        });
    const stored = sessionStorage.getItem('vehicleType');
    if (stored) {
      const type = localesReplacement(replacements, stored);
      setDropdownClassName(type);
    }
    return () => {
      controller.abort();
      isMounted = false;
    };
  }, [vehicleId]);
  useEffect(() => {
    if (products.length > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'recommendedOilView',
        'pageType': 'recommended oils',
        'oilName': products[0]?.recommendedProduct?.name,
        'oilCategory': `${products[0]?.name} ${products[0]?.code}`,
        'vehicleModel': `${vehicle?.make} ${vehicle?.model}`,
        'countryCode': localStorage.getItem('countryCode')
      })
    }
  }, [products]);

  // const alternateProducts = _.chain(products)
  //   .find(['name', products[component]?.name])
  //   .thru((d) => _.get(d, 'alternateProducts'))
  //   .value();

  const alternateProducts = products[component]?.alternateProducts;

  const castrolRecommendation = products[component];

  const handleShare = () => {
    const data = {
      title: `${vehicle?.make} - ${vehicle?.model} - ${vehicle?.type}`,
      text: localesReplacement(
        replacements,
        "Thank you for visiting Castrol Motor Oil and Fluid finder! Here's a link to the page you've shared"
      ) + '\n' + "Thank you for visiting Castrol Motor Oil and Fluid finder! Here's a link to the page you've shared",
      url: window.location.href,
    };
    if ('share' in navigator) {
      void (async function main() {
        try {
          await navigator.share(data);
        } catch (e) {
          const error = 1;
          throw new Error(error.toString());
        }
      })();
    } else {
      const body = encodeURIComponent(`${data.text} ${data.url}`)
      const url = `mailto:?subject=${encodeURIComponent(
        data.title
      )}&body=${body}`;
      window.location.href = url;
    }
  };

  const printOptions = {
    content: () => ref?.current,
    copyStyles: true,
  }
  const handlePrint = useReactToPrint(printOptions);

  const handleBack = () => {
    navigate(-1)
  };

  const selectVehicleHandle = (value: string | number, model: string, vehicleType?: string) => {
    if (vehicleType) {
      const type = localesReplacement(replacements, vehicleType);
      setDropdownClassName(type);
    }
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
  };
  const selectProductHandle = (value: string | number) => {
    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
    {/** FIXME: Currently above navigation is not working due to hash router, This is just a work around */ }
    location.reload();
  };

  const onWTBClick = () => {
    searchParams.set('page', 'wheretobuy');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
  };

  const onBack = useCallback(() => {
    searchParams.delete('page');
    searchParams.delete('id');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    isFastScan && searchParams.set('SearchState', 'Preserved');
    setSearchParams(searchParams);
  }, []);
  const componentDataLayer = (data: string) => {
    window.dataLayer.push({
      'event': 'recommendedOilView',
      'pageType': 'recommended oils',
      'oilName': products[0]?.recommendedProduct?.name,
      'oilCategory': data,
      'vehicleModel': `${vehicle?.make} ${vehicle?.model}`,
      'countryCode': localStorage.getItem('countryCode')
    })
  }

  const openModal = useCallback(() => {
    setModal({
      visibie: true,
      href: ModalHref.FindTheRightOil,
    });
  }, []);

  // const getAllRightsReservedInfo = () => {
  //   getProduct(productId).then((d) => {
  //     let name = d.data.description;
  //     if(name){
  //       name = name.split('</p>');
  //       setAllRightsRsrdName(name[0].toUpperCase());
  //       setAllRightsRsrdMsg(name[1]);
  //     }
  //   });
  // }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const renderMainContent = () => {
    return !_.isEmpty(products) ? (
      <div className={cx('main-content')}>
        {/* filter section */}
        {vehicle && (
          <div className={cx('filter-secion')}>
            <div className={cx('vehicle')} onClick={openModal}>
              <VehicleDropdown dataList={vehicle} className={dropdownClassName} />
            </div>
          </div>
        )}
        {/** tabs section */}
        <div className={cx('tabs')}>
          <ul>
            {_.map(products, (tab, index) => (
              <li key={index}>
                <span
                  className={`link ${cx({
                    actived: _.isEqual(component, index)
                  })} ${cx({ empty: 'recommendedProduct' in tab === false })}`}
                  role="link"
                  onClick={() => {
                    setComponent(index);

                    const code = tab['code'] ? `(${tab['code']})` : '';
                    componentDataLayer(`${tab['name']} ${code}}`)
                  }
                  }
                >
                  {tab['name']}{' '}
                  {tab['code'] ? `(${tab['code']})` : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className={cx('buttons')}>
          <button
            onClick={handlePrint}
            className={`${cx(primaryButton)} ${cx('print')}`}
          >
            {localesReplacement(replacements, "Print")}
          </button>
          <button
            onClick={handleShare}
            className={`${cx(primaryButton)} ${cx('share')}`}
          >
            {localesReplacement(replacements, "Share")}
          </button>

          <div className={cx('back-btn-plece')}>
            <button
              onClick={handleBack}
              className={`${cx(primaryButton)} ${cx('home')}`}
            >
              {localesReplacement(replacements, "Home")}
            </button>
            <button
              onClick={handleBack}
              className={`${cx(primaryButton)} ${cx('back')}`}
            >
              {localesReplacement(replacements, "Back")}
            </button>
          </div>

        </div>


        {/** Castrol Recommendation */}
        {!_.isEmpty(products) && (
          <>
            {castrolRecommendation && 'recommendedProduct' in castrolRecommendation && (
              <div className={cx('recommendation')}>
                <CastrolRecommendation
                  dataList={castrolRecommendation}
                  vehicle={vehicle}
                  notes={castrolRecommendation?.notes}
                  productCategories={
                    productCategoriesList ? productCategoriesList : []
                  }
                />
              </div>
            )}
            {'recommendedProduct' in castrolRecommendation === false &&
              <div className={cx('failed-recommendation')}>
                <FailedRecommendation
                  notes={castrolRecommendation?.notes}
                  replacements={replacements}
                />
              </div>
            }
            {/** Alternative Recommendation */}
            {!_.isEmpty(alternateProducts) && (
              <div className={cx('alertnative-section')}>
                <h3>
                  {localesReplacement(
                    replacements,
                    'Alternative Recommendation'
                  )}
                </h3>
                <div className={cx('rows')}>
                  {_.map(alternateProducts, (dataList, index) => (
                    <div key={index} className={cx('block')}>
                      <AlternativeRecommendation
                        dataList={dataList}
                        vehicle={vehicle}
                        notes={castrolRecommendation.notes}
                        productCategories={
                          productCategoriesList
                            ? productCategoriesList
                            : []
                        }
                        componentName={castrolRecommendation.name}
                        vehicleComponentVolumes={
                          castrolRecommendation.vehicleComponentVolumes
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* <div>
              <div className={cx('alr-color')}>
                <h4>{allRightsRsrdName !== ' ' ? Parser(allRightsRsrdName) : ''}</h4>
              </div>
              <div className={cx('alr-desc')} >
                {allRightsRsrdMsg !== ' ' ? Parser(allRightsRsrdMsg) : ''}
              </div>
            </div> */}

          </>
        )}
      </div>
    ) : (
      <div className={cx('no-content')}>
        <FailedRecommendation
          notes={castrolRecommendation?.notes}
          replacements={replacements}
        />
      </div>
    )
  }

  return (
    <>
      {castrolRecommendation && (
        <Printable
          vehicle={vehicle}
          ref={ref}
          data={products}
        />
      )}
      <div className={`page ${cx('page')}`}>
        <Header />
        <div className={cx('container')}>
          {/* Banner section */}
          <div className={cx('banner')}>
            <img src={publicImage('hero-image.jpg')} />
          </div>
          {/* Breadcrumb and titie above banner */}
          <div className={cx('heading')}>
            {isFastScan && (
              <span role='link'
                onClick={onBack}
                dangerouslySetInnerHTML={{ __html: '< Back' }}
                className='white-link'
              ></span>
            )}
            <Breadcrumb dataList={breadcrumb} />
            <h2>{localesReplacement(replacements, 'RECOMMENDED OILS')}</h2>
            {vehicle && _.isEmpty(products) ? (
              <div className={cx('main-content')}>
                <div className={cx('filter-secion')}>
                  <div className={cx('vehicle')} onClick={openModal}>
                    <VehicleDropdown dataList={vehicle} className={dropdownClassName} />
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* Main container */}
          {isMount ? <Loading /> :  ! underMaintnance ? renderMainContent() : (
            <div>
              <UnderMaintenance replacements={replacements}/>
            </div>
          )}
        </div>
      </div>
      {_.isEqual(modal.href, ModalHref.FindTheRightOil) && modal.visibie && (
        <Modal className={cx('abs-modal', 'abs-find-modal')}>
          <FindTheRightOil
            country={country}
            onVehicleSelect={(value: string | number, model: string, vehicleType?: string) => selectVehicleHandle(value, model, vehicleType)}
            onProductSelect={(value: string | number) => selectProductHandle(value)}
            onWTBClick={onWTBClick}
            i18n={i18n}
            locales={replacements}
            baseAPI={process.env.REACT_APP_PROVIDER_URL}
            restore={isFastScan}
          />
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  modal: state.modal,
  vehicle: state.filter.vehicle,
  replacements: state.replacements,
  productCategoriesList: state.productCategoriesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
  setVehicle: (vehicle: IVehicle) => dispatch(actions.setVehicle(vehicle)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
